import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Breadcrumb, Button, Col, Dropdown, Layout, Menu, Row } from "antd";
import Text from "antd/lib/typography/Text";
import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import logo from "../Assets/Logo.png";
import { AstenaLayoutProps } from "../Interfaces/AstenaLayoutProps";
import { useAppSelector } from "../Redux/hooks";
import { breadCrumbRoutes } from "../Router/BreadCrumbRoutes";
import RouteLinks from "../Router/RouteLinks";
import { AuthenticationService } from "../Services/AuthenticationService";
import "./HeaderLayout.css";

const HeaderLayout: React.FC<AstenaLayoutProps> = (props) => {

    const location = useLocation();
    const breadcrumbs = useBreadcrumbs(breadCrumbRoutes);
    const user = useAppSelector(state => state.user);
    let navigate = useNavigate();
    const [collapsed, setCollapsedState] = React.useState<boolean>(true);

    function toggleState(value: boolean) {
        setCollapsedState(value);
    }

    React.useEffect(() => {
        document.title = props.pageTitle;
        //console.log("rue of headerlayout")
    }, []);

    const NavigateHome = () => {
        navigate(`/${RouteLinks.service}/${RouteLinks.planning}`)
    };

    const logOut = () => {
        AuthenticationService.logout();
        navigate("/");
    }

    const menuHeaderDropdown = (
        <Menu className="menu">
            <Menu.Item key="logout" onClick={logOut}>
                <LogoutOutlined style={{ marginRight: ".4em" }} />
                Logout
            </Menu.Item>
        </Menu>
    );

    return (
        <Layout style={{ minHeight: "100vh" }} >

            <Layout>
                <Layout.Header style={{ background: "#1C253B" }}>
                    <Row wrap={false}>
                        <Col flex="auto">
                            <Row wrap={false} style={{ height: "100%" }}>
                                <div className="AppTitle" style={{ paddingLeft: 8, alignSelf: "center" }}>

                                    <Button
                                        className="ColapseBtn"
                                        type="link"
                                        onClick={NavigateHome}
                                        style={{ verticalAlign: "middle" }}
                                    >
                                        <img src={logo} alt="Logo" style={{ height: 45 }} />
                                    </Button>
                                </div>
                            </Row>
                        </Col>


                        <Col flex="none">
                            <div>
                                <div className="right dark ">
                                    <Dropdown overlay={menuHeaderDropdown}>
                                        <span className="action">
                                            <Text
                                                className="desktopHeader"
                                                style={{ paddingRight: 8 }}
                                            >
                                                {user.resourceName}
                                            </Text>
                                            <Avatar className="avatar" icon={<UserOutlined />} alt="avatar" />
                                        </span>
                                    </Dropdown>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </Layout.Header>
                <Layout>
                    <Layout style={{ padding: "0 8px 8px" }}>
                        <Layout.Content
                            className="site-layout-background"
                            style={{
                                padding: 5,
                                margin: 0,
                            }}
                        >
                            <Outlet />
                        </Layout.Content>
                    </Layout>
                </Layout>
            </Layout>
        </Layout>
    )
}

export default HeaderLayout;